import * as CryptoJS from "crypto-js"
import { useState } from "react"

const caches: { [key in string]: boolean } = {}

export const useAsyncLoading = (
  key?: string,
): [boolean, (func: Promise<unknown>) => Promise<void>] => {
  const [loading, setLoading] = useState(false)
  const asyncLoading = async (func: Promise<unknown>) => {
    const hash = key ?? CryptoJS.MD5((func as any).toString()).toString()
    setLoading(!caches[hash])
    await func
    caches[hash] = true
    setLoading(false)
  }
  return [loading, asyncLoading]
}
